import script from "./WizardModal.vue?vue&type=script&setup=true&lang=js"
export * from "./WizardModal.vue?vue&type=script&setup=true&lang=js"

import "./WizardModal.vue?vue&type=style&index=0&id=50a7d1f7&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-50a7d1f7"]])

export default __exports__